import { Component, Inject, OnInit } from "@angular/core";
import { NgForm } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { TsiProject } from "app/_models/tsi-project";
import { CrudInvProjectService } from "app/_services/MasterCrudOps/crud-inv-project.service";
declare const swal: any;

@Component({
  selector: "app-edit-inv-project",
  templateUrl: "./edit-inv-project.component.html",
  styleUrls: ["./edit-inv-project.component.css"],
})
export class EditInvProjectComponent implements OnInit {
  editProject: TsiProject;
  pageNumber: Number;
  pageSize: Number;

  constructor(
    private router: Router,
    private crudProjectService: CrudInvProjectService,
    private dialogRef: MatDialogRef<EditInvProjectComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any)
   {
    this.editProject = JSON.parse(JSON.stringify(data.project));
    this.pageNumber = data.pageNumber;
    this.pageSize = data.pageSize;
   }

  ngOnInit(): void {}

  saveProject() {
    swal({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: "btn btn-success",
      cancelButtonClass: "btn btn-danger",
      confirmButtonText: "YES, Update IT!",
    }).then((result) => {
      if (result === true) {
        this.updateProject();
      }
    });
  }

  updateProject() {
    this.crudProjectService
      .updateInvProject(
        this.editProject.invProjectId,
        this.editProject.projectName,
        this.editProject.description
      )
      .subscribe
    (
      data => {     
                if (data.didError) {
                  swal({
                    title: '',
                    text: data.message,
                    type: 'error',
                    confirmButtonClass: 'btn btn-info'
                  });
                }
                else {
                  this.dialogRef.close(true);
                  swal({
                    title: '',
                    text: data.message,
                    type: 'success',
                    confirmButtonClass: 'btn btn-info'
                  });
                  let result = {
                    status: true,
                    pageNumber: this.pageNumber,
                    pageSize: this.pageSize
                  };
                  this.dialogRef.close(result);
                }
              },
     (error) => 
            {
              const errorMessage =  error.error?.title || error.error ||'Something went wrong. Please contact admin.';
              swal({
                title: '',
                text: errorMessage,
                type: 'error',
                confirmButtonClass: 'btn btn-info'
              });
            }
    )
     
  }

  close() {
    let result = {
      status: false,
      pageNumber: this.pageNumber,
      pageSize: this.pageSize
    };
    this.dialogRef.close(result);
  }
}
